const development = [
  {
    name: "web development",
    id: "c1s1",
  },
  {
    name: "data science",
    id: "c1s2",
  },
  {
    name: "mobile development",
    id: "c1s3",
  },
  {
    name: "programming languages",
    id: "c1s4",
  },
  {
    name: "game development",
    id: "c1s5",
  },
  {
    name: "detabase design & development",
    id: "c1s6",
  },
  {
    name: "software testing",
    id: "c1s7",
  },
  {
    name: "software engineering",
    id: "c1s8",
  },
  {
    name: "software development tools",
    id: "c1s9",
  },
  {
    name: "no-code development",
    id: "c1s10",
  },
];
const business = [
  {
    name: "enterpreneurship",
    id: "c2s1",
  },
  {
    name: "communication",
    id: "c2s2",
  },
  {
    name: "management",
    id: "c2s3",
  },
  {
    name: "sales",
    id: "c2s4",
  },
  {
    name: "business strategy",
    id: "c2s5",
  },
  {
    name: "operations",
    id: "c2s6",
  },
  {
    name: "project management",
    id: "c2s7",
  },
  {
    name: "business low",
    id: "c2s8",
  },
  {
    name: "business analytics & intelligence",
    id: "c2s9",
  },
  {
    name: "human resources",
    id: "c2s10",
  },
  {
    name: "industry",
    id: "c2s11",
  },
  {
    name: "e-commerce",
    id: "c2s12",
  },
  {
    name: "media",
    id: "c2s13",
  },
  {
    name: "real estate",
    id: "c2s14",
  },
  {
    name: "other business",
    id: "c2s15",
  },
];
const financeAndAccounting = [
  {
    name: "accounting & bookkeeing",
    id: "c3s1",
  },
  {
    name: "compliance",
    id: "c3s2",
  },
  {
    name: "cryptocurrency & blockchain",
    id: "c3s3",
  },
  {
    name: "economics",
    id: "c3s4",
  },
  {
    name: "finace",
    id: "c3s5",
  },
  {
    name: "finace cert & exam prep",
    id: "c3s6",
  },
  {
    name: "financial modeling & analysis",
    id: "c3s7",
  },
  {
    name: "investing & trading",
    id: "c3s8",
  },
  {
    name: "money management",
    id: "c3s9",
  },
  {
    name: "taxes",
    id: "c3s10",
  },
  {
    name: "pther finance & accounting",
    id: "c3s11",
  },
];
const itAndSoftware = [
  {
    name: "IT certifications",
    id: "c4s1",
  },
  {
    name: "network & security",
    id: "c4s2",
  },
  {
    name: "hardware",
    id: "c4s3",
  },
  {
    name: "operating systems & servers",
    id: "c4s4",
  },
  {
    name: "other IT & software",
    id: "c4s5",
  },
];

const officeProductivity = [
  {
    name: "microsoft",
    id: "c5s1",
  },
  {
    name: "apple",
    id: "c5s2",
  },
  {
    name: "google",
    id: "c5s3",
  },
  {
    name: "SAP",
    id: "c5s4",
  },
  {
    name: "oracle",
    id: "c5s5",
  },
  {
    name: "other office productivity",
    id: "c5s6",
  },
];
const personalDevelopment = [
  {
    name: "personal transformation",
    id: "c6s1",
  },
  {
    name: "personal productivity",
    id: "c6s2",
  },
  {
    name: "leadership",
    id: "c6s3",
  },
  {
    name: "career development",
    id: "c6s4",
  },
  {
    name: "parenting and relationships",
    id: "c6s5",
  },
  {
    name: "happiness",
    id: "c6s6",
  },
  {
    name: "esoteric practices",
    id: "c6s7",
  },
  {
    name: "religion & spirituality",
    id: "c6s8",
  },
  {
    name: "personal branc building",
    id: "c6s9",
  },
  {
    name: "creativity",
    id: "c6s10",
  },
  {
    name: "influence",
    id: "c6s11",
  },
  {
    name: "self esteem & confidence",
    id: "c6s12",
  },
  {
    name: "stress management",
    id: "c6s13",
  },
  {
    name: "memory & study skills",
    id: "c6s14",
  },
  {
    name: "motivation",
    id: "c6s15",
  },
  {
    name: "other personal development",
    id: "c6s16",
  },
];
const design = [
  {
    name: "web design",
    id: "c7s1",
  },
  {
    name: "craphic design & illustration",
    id: "c7s2",
  },
  {
    name: "design tools",
    id: "c7s3",
  },
  {
    name: "user experience design",
    id: "c7s4",
  },
  {
    name: "game design",
    id: "c7s5",
  },
  {
    name: "3D & animation",
    id: "c7s6",
  },
  {
    name: "fashion design",
    id: "c7s7",
  },
  {
    name: "architectural design",
    id: "c7s8",
  },
  {
    name: "interior design",
    id: "c7s9",
  },
  {
    name: "other design",
    id: "c7s10",
  },
];

const marketing = [
  {
    name: "degital marketing",
    id: "c8s1",
  },
  {
    name: "search engine optimization",
    id: "c8s2",
  },
  {
    name: "social media marketing",
    id: "c8s3",
  },
  {
    name: "branding",
    id: "c8s4",
  },
  {
    name: "marketing fundamentals",
    id: "c8s5",
  },
  {
    name: "marketing analytics & automation",
    id: "c8s6",
  },
  {
    name: "public relations",
    id: "c8s7",
  },
  {
    name: "paid advertising",
    id: "c8s8",
  },
  {
    name: "video & mobile marketing",
    id: "c8s9",
  },
  {
    name: "content marketing",
    id: "c8s10",
  },
  {
    name: "growth hacking",
    id: "c8s11",
  },
  {
    name: "affiliate marketing",
    id: "c8s12",
  },
  {
    name: "product marketing",
    id: "c8s13",
  },
  {
    name: "other marketing",
    id: "c8s14",
  },
];
const lifestyle = [
  {
    name: "art & crafts",
    id: "c9s1",
  },
  {
    name: "beauty & makeup",
    id: "c9s2",
  },
  {
    name: "esoteric practices",
    id: "c9s3",
  },
  {
    name: "food & beverage",
    id: "c9s4",
  },
  {
    name: "gaming",
    id: "c9s5",
  },
  {
    name: "home improvement & gardening",
    id: "c9s6",
  },
  {
    name: "pet care & training",
    id: "c9s7",
  },
  {
    name: "travel",
    id: "c9s8",
  },
  {
    name: "other lifestyle",
    id: "c9s9",
  },
];

const photographyAndVideo = [
  {
    name: "digital photography",
    id: "c10s1",
  },
  {
    name: "photography",
    id: "c10s2",
  },
  {
    name: "portrait photography",
    id: "c10s3",
  },
  {
    name: "photography tools",
    id: "c10s4",
  },
  {
    name: "commercial photography",
    id: "c10s5",
  },
  {
    name: "video design",
    id: "c10s6",
  },
  {
    name: "other photography & video",
    id: "c10s7",
  },
];

const healthAndFitness = [
  {
    name: "fitness",
    id: "c11s1",
  },
  {
    name: "general health",
    id: "c11s2",
  },
  {
    name: "sports",
    id: "c11s3",
  },
  {
    name: "nutrition & diet",
    id: "c11s4",
  },
  {
    name: "yoga",
    id: "c11s5",
  },
  {
    name: "mental health",
    id: "c11s6",
  },
  {
    name: "material arts & self defense",
    id: "c11s7",
  },
  {
    name: "safety & first aid",
    id: "c11s8",
  },
  {
    name: "dance",
    id: "c11s9",
  },
  {
    name: "meditation",
    id: "c11s10",
  },
  {
    name: "other health & fitness",
    id: "c11s11",
  },
];

const music = [
  {
    name: "instruments",
    id: "c12s1",
  },
  {
    name: "music production",
    id: "c12s2",
  },
  {
    name: "music fundamentals",
    id: "c12s3",
  },
  {
    name: "vocal",
    id: "c12s4",
  },
  {
    name: "music techniques",
    id: "c12s5",
  },
  {
    name: "music software",
    id: "c12s6",
  },
  {
    name: "other music",
    id: "c12s7",
  },
];

const teachingAndAcademic = [
  {
    name: "engineering",
    id: "c13s1",
  },
  {
    name: "humanities",
    id: "c13s2",
  },
  {
    name: "math",
    id: "c13s3",
  },
  {
    name: "science",
    id: "c13s4",
  },
  {
    name: "online education",
    id: "c13s5",
  },
  {
    name: "social science",
    id: "c13s6",
  },
  {
    name: "language learning",
    id: "c13s7",
  },
  {
    name: "teacher training",
    id: "c13s8",
  },
  {
    name: "test prep",
    id: "c13s9",
  },
  {
    name: "other teaching & academics",
    id: "c13s10",
  },
];

export const subCategories = [
  {
    id: "c1",
    categories: development,
  },
  {
    id: "c2",
    categories: business,
  },
  {
    id: "c3",
    categories: financeAndAccounting,
  },
  {
    id: "c4",
    categories: itAndSoftware,
  },
  {
    id: "c5",
    categories: officeProductivity,
  },
  {
    id: "c6",
    categories: personalDevelopment,
  },
  {
    id: "c7",
    categories: design,
  },
  {
    id: "c8",
    categories: marketing,
  },
  {
    id: "c9",
    categories: lifestyle,
  },
  {
    id: "c10",
    categories: photographyAndVideo,
  },
  {
    id: "c11",
    categories: healthAndFitness,
  },
  {
    id: "c12",
    categories: music,
  },
  {
    id: "c13",
    categories: teachingAndAcademic,
  },
];
